import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { InsuranceType } from '@features/insurances/models/insurance-type.enum';

@Pipe({
  name: 'insuranceType',
  standalone: true
})
export class InsuranceTypePipe implements PipeTransform {
  transform(value: string | number): string {
    if (!value) {
      return '';
    }
    const numericValue = typeof value === 'string' ? parseInt(value, 10) : value;
    if (isNaN(numericValue)) {
      return value as string;
    }

    return InsuranceType.getDisplayName(numericValue) ?? value.toString();
  }
}
